'use client'
import {
  ControlBox
} from "./chunk-P2CZ2AGB.mjs";
export {
  ControlBox
};
//# sourceMappingURL=index.mjs.map